import Topbar from "./Topbar";
import Mobile from "./Mobile";
import Main from "./Main";

export default { Topbar, Mobile, Main};